var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleContainer"},[_c('div',{staticClass:"common-title"},[_vm._v(_vm._s(_vm.title))]),_c('small',{staticClass:"common-subtitle"},[_vm._v(_vm._s(_vm.subTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }